import styled from '@emotion/styled';
import theme from '@vromo/ui/components/theme';

export const GridCellDisplay = styled.div`
    padding: 10px;
    border-right: solid 1px #e7eaec;
    border-bottom: solid 1px #e7eaec;
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const GridHeaderCellDisplay = styled(GridCellDisplay)`
    font-weight: bold;
    text-align: center;
    cursor: pointer;
`;

export const CommentLink = styled.div`
    color: ${theme.primary};
    cursor: pointer;
`;
